import { useSelector } from 'react-redux';

import { IAppState } from '../../common/state';
import { EJsonQueryPriceType } from '../../repositories/common/json_query';

export function usePriceTypeSelector() {
  return useSelector<IAppState, EJsonQueryPriceType | undefined>(state => state.filters.jsonQuery.price_type?.value);
}
